import React, { useState } from "react"
import Button from "../../../shared/components/atoms/button/button"
import ModalMailRecovery from "../../molecules/modal-mail-recovery/modal-mail-recovery"
import ModalPhoneRecovery from "../../molecules/modal-phone-recovery/modal-phone-recovery"

import "./recover-content.scss"
import AuthService from "../../../shared/services/auth-service"

const RecoverContent = props => {
  var isBrowser = typeof window !== "undefined"
  var isNumeric = isBrowser
    ? sessionStorage.getItem("currentUserNumeric") === "true"
    : false
  var inputUser = isBrowser
    ? sessionStorage.getItem("currentUserValue") !== null
      ? sessionStorage.getItem("currentUserValue")
      : ""
    : ""

  const [checkedMedium, setCheckedMedium] = useState(
    isBrowser ? (isNumeric ? "sms" : "mail") : "mail"
  )

  const [inputCellValue, setInputCellValue] = useState(
    isNumeric ? inputUser : ""
  )
  const [inputMailValue, setInputMailValue] = useState(
    !isNumeric ? inputUser : ""
  )

  const [mailError, setMailError] = useState(false)
  const [cellPhoneError, setCellPhoneError] = useState(false)
  const [disabledBtn, setDisabledBtn] = useState(false)
  const [userError, setUserError] = useState(null)

  const mailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

  const handleMediumChange = e => {
    setCheckedMedium(e.target.value)
  }

  const mistakeCellByCountry = num => {
    return (
      num.toString().length < parseInt(process.env.MIN_DIGITS) ||
      num.toString().length > parseInt(process.env.MAX_DIGITS)
    )
  }

  const handleSubmit = () => {

    if (checkedMedium === "mail") {
      if (inputMailValue === "") {
        setMailError(true)
      } else {
        if (mailRegex.test(inputMailValue)) {
          setMailError(false)
          setDisabledBtn(true)

          AuthService.recoveryPass(
            inputMailValue.toLocaleLowerCase(),
            checkedMedium
          ).then(res => {
            if (res.status === 200) {
              props.setModalACtive(<ModalMailRecovery />)
            } else {
              setUserError(res.userMessage)
              setTimeout(() => {
                setUserError(null)
                setDisabledBtn(false)
              }, 10000)
            }
          })
        } else {
          setMailError(true)
        }
      }
    }
    if (checkedMedium === "sms") {
      if (inputCellValue === "" || mistakeCellByCountry(inputCellValue)) {
        setCellPhoneError(true)
      } else {
        setDisabledBtn(true)
        setCellPhoneError(false)
        let cellPhone =
          process.env.LOCALE === "es-PY"
            ? parseInt(inputCellValue, 10).toString()
            : parseInt(inputCellValue).toString()

        AuthService.recoveryPass(cellPhone, checkedMedium).then(res => {
          if (res.status === 200) {
            props.setModalACtive(<ModalPhoneRecovery />)
          } else {
            setUserError(res.userMessage)
            setTimeout(() => {
              setUserError(null)
              setDisabledBtn(false)
            }, 10000)
          }
        })
      }
    }
  }
  return (
    <div className="f-recover">
      <div className="f-recover-content">
        <div className="f-recover-container">
          <a className="icon2-close f-close-icon" href="/login" />
          <div className="f-info-recover">
            <h1 className="f-recover-title">Recuperar</h1>
            <label className="f-recover-subtitle">TU CONTRASEÑA</label>
            <div className="f-recover-form-container">
              <label className="f-description-recover">
                Selecciona el medio por cual quieres recuperar tu contraseña.
              </label>
              <div className="f-recover-group-input">
                <label className="f-label-form-recover f-label-radio">
                  ¿POR QUÉ MEDIO QUIERES RECUPERAR TU CONTRASEÑA?
                </label>
                <div className="f-radio-group">
                  <div className="f-radio-container">
                    <input
                      type="radio"
                      className="f-medium"
                      name="f-medium-mail"
                      value="mail"
                      onChange={e => handleMediumChange(e)}
                      checked={checkedMedium === "mail"}
                    />
                    <span className="checkmark"></span>
                    <label className="f-radio-label"> Mi correo</label>
                  </div>
                  <div className="f-radio-container">
                    <input
                      type="radio"
                      className="f-medium"
                      name="f-medium-sms"
                      value="sms"
                      onChange={e => handleMediumChange(e)}
                      checked={checkedMedium === "sms"}
                    />
                    <span className="checkmark"></span>
                    <label className="f-radio-label"> Mi celular (SMS)</label>
                  </div>
                </div>
              </div>
              {checkedMedium === "mail" && (
                <div className="f-recover-group-input">
                  <label className="f-label-form-recover f-label-email">
                    CORREO ELECTRÓNICO
                  </label>
                  <input
                    className={
                      "f-input-recover " + (mailError ? "f-error-input" : "")
                    }
                    name="f-input-recover-email"
                    type="text"
                    value={inputMailValue.trim()}
                    onChange={e => setInputMailValue(e.target.value)}
                  />
                  <span className="f-error-form">
                    {mailError && "*Correo inválido"}
                    {userError !== null && "*" + userError}
                  </span>
                </div>
              )}
              {checkedMedium === "sms" && (
                <div className="f-recover-group-input">
                  <label className="f-label-form-recover f-label-email">
                    NÚMERO DE CELULAR
                  </label>
                  <input
                    className={
                      "f-input-recover " +
                      (cellPhoneError ? "f-error-input" : "")
                    }
                    name="f-input-recover-cellphone"
                    type="number"
                    value={inputCellValue}
                    onChange={e => setInputCellValue(e.target.value)}
                  />
                  <span className="f-error-form">
                    {cellPhoneError && "*Número de celular inválido"}
                    {userError !== null && "*" + userError}
                  </span>
                </div>
              )}
            </div>
            <div className="f-button-action-container" onClick={handleSubmit}>
              <Button className="new- primary-pink short" title="Enviar" />

              {disabledBtn && (
                <div
                  className="f-btn-disabled-mask"
                  onClick={e => e.stopPropagation()}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RecoverContent
